import { render, staticRenderFns } from "./FormToca.vue?vue&type=template&id=65abca45&"
import script from "./FormToca.vue?vue&type=script&lang=js&"
export * from "./FormToca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports